/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdFrequencyCapResponseDto } from "./AdFrequencyCapResponseDto";
import type { HalfViewCpeContentResponseDto } from "./HalfViewCpeContentResponseDto";
import type { HalfViewCpmContentResponseDto } from "./HalfViewCpmContentResponseDto";
import type { SimpleContentResponseDto } from "./SimpleContentResponseDto";
export type AdDto = {
  /**
   * 광고 ID
   */
  id: string;
  /**
   * 광고그룹 ID
   */
  adGroupId: string;
  /**
   * 광고그룹명
   */
  adGroupName: string;
  /**
   * 광고그룹 상태
   */
  adGroupStatus: AdDto.adGroupStatus;
  /**
   * 캠페인 ID
   */
  campaignId: string;
  /**
   * 캠페인명
   */
  campaignName: string;
  /**
   * 캠페인 상태
   */
  campaignStatus: AdDto.campaignStatus;
  /**
   * 광고주 ID
   */
  advertiserId: string;
  /**
   * 광고주 회사명
   */
  advertiserName: string;
  /**
   * 광고명
   */
  name: string;
  /**
   * 광고 타입
   */
  type: AdDto.type;
  /**
   * 광고 배지 표시 여부
   */
  showAdBadge: boolean;
  /**
   * 클릭 보상 지급 여부 (값 없던 예전 광고는 true)
   */
  clickRewardEnabled: boolean;
  /**
   * 광고 콘텐츠 (타입별 다른 구조)
   */
  content:
    | HalfViewCpeContentResponseDto
    | HalfViewCpmContentResponseDto
    | SimpleContentResponseDto;
  /**
   * 프리퀀시 캡 설정
   */
  frequencyCap?: AdFrequencyCapResponseDto;
  /**
   * 상태
   */
  status: AdDto.status;
  /**
   * 삭제 여부
   */
  isDeleted: boolean;
  /**
   * 삭제일
   */
  deletedAt?: string;
  /**
   * 생성일
   */
  createdAt: string;
  /**
   * 수정일
   */
  updatedAt: string;
};
export namespace AdDto {
  /**
   * 광고그룹 상태
   */
  export enum adGroupStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
  /**
   * 캠페인 상태
   */
  export enum campaignStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
  /**
   * 광고 타입
   */
  export enum type {
    HALF_VIEW_CPE = "HALF_VIEW_CPE",
    HALF_VIEW_CPM = "HALF_VIEW_CPM",
    LIGHT_VIEW_CPE = "LIGHT_VIEW_CPE",
    LIGHT_VIEW_CPM = "LIGHT_VIEW_CPM",
    CPQ = "CPQ",
    TOP_BANNER = "TOP_BANNER",
    EXCHANGE = "EXCHANGE",
    QUIZ_CREATION = "QUIZ_CREATION",
  }
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
